import { useContext } from 'react';
import { KYCSettingsActionsContext, KYCSettingsStateSelectorsContext } from './KYCSettingsProvider';

export const useKYCSettingsStateSelectorsContext = () =>
    useContext(KYCSettingsStateSelectorsContext);
    
export const useKYCSettingsActionsContext = () =>
    useContext(KYCSettingsActionsContext);
